define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump', 'underscore'],
    function ($, transit, modernizr, container, preloader, jumpFactory, _) {

        return (function () {

            const name = 'module-movie-guide';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {
                loadedItems: new Map()
            };

            model.methods = {
                getMovieGuide: function (id) {

                    if(model.privateVars.loadedItems.has(id)) {
                        pubSub.publish('view/actionShowMovieGuide', model.privateVars.loadedItems.get(id));
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxMovieGuideEndpoint + '/' + id,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(id, data);
                            pubSub.publish('view/actionShowMovieGuide', data);
                        });
                    }
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                anim: 0
            };

            view.startup = function () {

            };

            view.bind = function () {
                $(view.publicVars.cssId.movieGuideListItemBlockCls + '' + view.publicVars.cssId.hasMoreInfoCls).click(function () {
                    const id = parseInt(container.getData($(this)[0], 'id'));
                    const title = container.getData($(this)[0], 'title');

                    if(view.privateVars.anim === 0) {
                        view.privateVars.anim = 1;

                        if($(this).hasClass(view.publicVars.cssId.isActiveCls.substr(1))) {
                            view.methods.closeItem(id);
                        } else {
                            container.trackInteraction('show movie guide open click', {
                                'subsection': 'series|movie-guide',
                                'contenttype': 'movie-guide',
                                'contenttitle': title.toLowerCase().replace(/"/g, "'")
                            });

                            view.methods.handleItemOpen(id);
                        }
                    }
                });

                $(window).resize(function () {
                    view.methods.handleScreenResize();
                });

                $(window).on("orientationchange", function () {
                    view.methods.handleScreenResize();
                });
            };

            view.methods = {

                handleScreenResize: () => {
                    $(view.publicVars.cssId.movieGuideListItemBlockCls).each(function() {
                        if($(this).hasClass(view.publicVars.cssId.isActiveCls.substr(1))) {
                            let id = container.getData($(this)[0], 'id');

                            if($(view.publicVars.cssId.movieGuideListItemContentCls + id)
                                .hasClass(view.publicVars.cssId.hasImageCls.substr(1))) {

                                let imageHeight = $(view.publicVars.cssId.movieGuideListItemContentImageWrapperCls,
                                    view.publicVars.cssId.movieGuideListItemContentCls + id).outerHeight();

                                let contentHeight = $(view.publicVars.cssId.movieGuideListItemContentAreaCls,
                                    view.publicVars.cssId.movieGuideListItemContentCls + id).outerHeight();

                                if (contentHeight > imageHeight) {
                                    $(view.publicVars.cssId.movieGuideListItemContentCls + id)
                                        .addClass(view.publicVars.cssId.hasLongContentCls.substr(1));
                                } else {
                                    $(view.publicVars.cssId.movieGuideListItemContentCls + id)
                                        .removeClass(view.publicVars.cssId.hasLongContentCls.substr(1));
                                }
                            }

                        }
                    });
                },

                closeItem: (id) => {
                    view.privateVars.anim = 0;
                    $(view.publicVars.cssId.movieGuideListItemContentCls + id).removeAttr('style');
                    $(view.publicVars.cssId.movieGuideListItemBlockCls + id).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.movieGuideListItemContentAreaCls,
                        view.publicVars.cssId.movieGuideListItemContentCls + id).html('');
                },

                handleItemOpen: (id) => {
                    const oldHeight = 257;

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    const newWindowHeight = $(window).height() - submenuHeight - headerHeight;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 0;
                    }

                    let newHeight = oldHeight;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                    }

                    $(view.publicVars.cssId.movieGuideListItemBlockCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.movieGuideListItemContentCls + id).css({ display: 'block', visibility: 'visible', opacity: '1'});

                    $(view.publicVars.cssId.movieGuideListItemContentCls + id).css({
                        height: 0
                    });

                    $(view.publicVars.cssId.movieGuideListItemContentAreaCls,
                        view.publicVars.cssId.movieGuideListItemContentCls + id).html('');

                    $(view.publicVars.cssId.movieGuideListItemContentCls + id).transit({
                        height: newHeight + 'px'
                    }, 300, () => {
                        $(view.publicVars.cssId.movieGuideLoaderId + id).css({ display: 'block', opacity: 0});

                        $(view.publicVars.cssId.movieGuideLoaderId + id).transit({ opacity: 1 });

                        jump.centerTo(view.publicVars.cssId.movieGuideLoaderId + id, () => {
                            model.methods.getMovieGuide(id);
                        }, {
                            modifier: - parseInt(headerHeight + submenuHeight)
                        });
                    });
                },

                actionShowMovieGuide: (action, data) => {
                    data.alt = data.header.replace(/\"/g, '');

                    if(data.item_images[data.id]) {

                        $(view.publicVars.cssId.movieGuideListItemContentCls + data.id)
                            .addClass(view.publicVars.cssId.hasImageCls.substr(1));

                        preloader.preloadSingleImage(name, data.item_images[data.id], () => {
                            view.methods.actionShowMovieGuideWrapped(data);
                        });
                    } else {
                        view.methods.actionShowMovieGuideWrapped(data);
                    }
                },

                actionShowMovieGuideWrapped: (data) => {
                    const compiled = _.template($(view.publicVars.cssId.templateId).html());

                    const output = compiled({
                        data: data
                    });

                    const handle = $(view.publicVars.cssId.movieGuideListItemContentAreaCls,
                        view.publicVars.cssId.movieGuideListItemContentCls + data.id);

                    handle.html(output);

                    handle.css({ display: 'block', opacity: 1});

                    const newHeight = handle.outerHeight();

                    if(data.item_images[data.id]) {

                        const imageHeight = $(view.publicVars.cssId.movieGuideListItemContentImageWrapperCls,
                            view.publicVars.cssId.movieGuideListItemContentCls + data.id).outerHeight();

                        if (imageHeight < newHeight) {
                            $(view.publicVars.cssId.movieGuideListItemContentCls + data.id)
                                .addClass(view.publicVars.cssId.hasLongContentCls.substr(1));
                        }
                    }

                    handle.css({ display: 'none', opacity: 0});

                    $(view.publicVars.cssId.movieGuideLoaderId + data.id).removeAttr('style');

                    $(view.publicVars.cssId.movieGuideListItemContentCls + data.id).transit({ height: newHeight + 'px'}, 300, () => {
                        handle.css({ display: 'block', opacity: 0});
                        handle.transit({opacity: 1}, 300, function () {
                            view.privateVars.anim = 0;
                            $(view.publicVars.cssId.movieGuideListItemContentCls + data.id).removeAttr('style');
                            $(view.publicVars.cssId.movieGuideListItemContentCls + data.id).css({ display: 'block'});
                        });
                    });
                }
            };

            /* custom events */
            pubSub.subscribe('view/actionShowMovieGuide', view.methods.actionShowMovieGuide);
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
